export enum OdaxObjectiveEnum {
    OUTCOME_AWARENESS = 'OUTCOME_AWARENESS',
    OUTCOME_APP_PROMOTION = 'OUTCOME_APP_PROMOTION',
    OUTCOME_ENGAGEMENT = 'OUTCOME_ENGAGEMENT',
    OUTCOME_LEADS = 'OUTCOME_LEADS',
    OUTCOME_SALES = 'OUTCOME_SALES',
    OUTCOME_TRAFFIC = 'OUTCOME_TRAFFIC'
}